export enum APIKeyStatus {
  Active = 'active',
  Revoked = 'revoked',
}

export interface APIKey {
  id: number;
  name: string;
  status: APIKeyStatus;
  token: string;
  created_at: string;
}
